<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>

<style>
	thead th {
		position: -webkit-sticky;
		position: sticky;
	}
	thead tr.level1 th {
		top: 1px;
	}
	thead tr.level2 th {
		top: 51px;
	}

	.nowraptdth th, td {
		white-space: nowrap;
	}

	sup i.fa-infinity {
		color: #0b62ff;
	}
</style>

<div class="row">
	<div class="col-md-1"></div>
	<div class="col-md-10">
		<loading [isLoad]="statsLoader"></loading>

		<table class="table nowraptdth" *ngIf="!statsLoader">
			<thead>
			<tr class="level1">
				<th class="table-primary" colspan="2">&nbsp;</th>
				<th class="table-success" colspan="6">нулевой день</th>
				<th class="table-info" colspan="6">не нулевой</th>
				<th class="table-primary" colspan="2">&nbsp;</th>
			</tr>
			<tr class="table-primary level2">
				<th>Месяц</th>
				<th>Первый платеж</th>
				
				<th>Пользователей<sup>C</sup></th>
				<th>Первичные, $<sup>D</sup></th>
				<th>Все платежи, $<sup>E</sup></th>
				<th>LTV, $<sup ngbTooltip="ƒ=E/C"><i class="fas fa-infinity"></i></sup></th>
				<th>Живых<sup>G</sup></th>
				<th>Живых, %<sup>H</sup></th>
				
				<th>Пользователей<sup>I</sup></th>
				<th>Первичные, $<sup>J</sup></th>
				<th>Все платежи, $<sup>K</sup></th>
				<th>LTV, $<sup ngbTooltip="ƒ=K/I"><i class="fas fa-infinity"></i></sup></th>
				<th>Живых<sup>M</sup></th>
				<th>Живых, %<sup>N</sup></th>
				
				<th>Дельта LTV<sup ngbTooltip="ƒ=(L-F)/L"><i class="fas fa-infinity"></i></sup></th>
				<th>Относительное LTV<sup ngbTooltip="ƒ=L5/F5"><i class="fas fa-infinity"></i></sup></th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let row of tables.zero; let i = index;" [style.font-weight]="row.type == 'total' ? 'bold' : 'normal'">
				<ng-template [ngIf]="row.type != 'space'">
					<td>{{row.month}}</td>
					<td>{{row.tariff}}</td>
					
					<td>{{row.userCount}}</td>
					<td>{{row.manualPaidAmount | number : '1.2-2'}}</td>
					<td>{{row.allPaidAmount | number : '1.2-2'}}</td>
					<td>{{row.LTV | number : '1.2-2'}}</td>
					<td>{{row.userPaidCount}}</td>
					<td>{{row.userPaidCountPercent | number : '1.2-2'}}%</td>
					
					<td>{{tables.noZero[i].userCount}}</td>
					<td>{{tables.noZero[i].manualPaidAmount | number : '1.2-2'}}</td>
					<td>{{tables.noZero[i].allPaidAmount | number : '1.2-2'}}</td>
					<td>{{tables.noZero[i].LTV | number : '1.2-2'}}</td>
					<td>{{tables.noZero[i].userPaidCount}}</td>
					<td>{{tables.noZero[i].userPaidCountPercent | number : '1.2-2'}}%</td>

					<td>{{((tables.noZero[i].LTV - row.LTV) / tables.noZero[i].LTV) * 100 | number : '1.2-2'}}%</td>
					<td>{{(tables.noZero[i].LTV / row.LTV) * 100 | number : '1.2-2'}}%</td>
				</ng-template>
				<ng-template [ngIf]="row.type == 'space'">
					<td colspan="15"></td>
				</ng-template>
			</tr>
			</tbody>
		</table>
	</div>
	<div class="col-md-1"></div>
</div>

<br>

<div class="row">
	<div class="col-md-1"></div>
	<div class="col-md-7">
		<table class="table nowraptdth" *ngIf="!statsLoader">
			<thead>
			<tr class="level1">
				<th class="table-primary" colspan="2">&nbsp;</th>
				<th class="table-warning" colspan="4">перереги</th>
				<th class="table-danger" colspan="4">без перерег</th>
			</tr>
			<tr class="table-primary level2">
				<th>Месяц</th>
				<th>Первый платеж</th>
				
				<th>Пользователей<sup>C</sup></th>
				<th>Первичные, $<sup>D</sup></th>
				<th>Все платежи, $<sup>E</sup></th>
				<th>LTV, $<sup ngbTooltip="ƒ=E/C"><i class="fas fa-infinity"></i></sup></th>

				<th>Пользователей<sup>G</sup></th>
				<th>Первичные, $<sup>H</sup></th>
				<th>Все платежи, $<sup>I</sup></th>
				<th>LTV, $<sup ngbTooltip="ƒ=I/G"><i class="fas fa-infinity"></i></sup></th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let row of tables.hasRereg; let i = index;" [style.font-weight]="row.type == 'total' ? 'bold' : 'normal'">
				<ng-template [ngIf]="row.type != 'space'">
					<td>{{row.month}}</td>
					<td>{{row.tariff}}</td>
					
					<td>{{row.userCount}}</td>
					<td>{{row.manualPaidAmount | number : '1.2'}}</td>
					<td>{{row.allPaidAmount | number : '1.2'}}</td>
					<td>{{row.LTV | number : '1.2'}}</td>

					<td>{{tables.noRefeg[i].userCount}}</td>
					<td>{{tables.noRefeg[i].manualPaidAmount | number : '1.2'}}</td>
					<td>{{tables.noRefeg[i].allPaidAmount | number : '1.2'}}</td>
					<td>{{tables.noRefeg[i].LTV | number : '1.2'}}</td>
				</ng-template>
				<ng-template [ngIf]="row.type == 'space'">
					<td colspan="10"></td>
				</ng-template>
			</tr>
			</tbody>
		</table>
	</div>
	<div class="col-md-4"></div>
</div>
